const MOST_FREQUENT_SEARCHES_QUERY = `
  query MostFrequentSearchesQuery {
    public {
      mostFrequentSearches
    }
  }
`;

export default MOST_FREQUENT_SEARCHES_QUERY;
